import templateUrl from './statement-of-benefits-edit.html'

export const statementOfBenefitsEditComponent = {
    templateUrl,
    bindings: {
        details: '<'
    },
    controller: class StatementOfBenefitsEditComponent {
        constructor(ModalService, toastr, $state, CompareObjectService, StatementOfBenefitsService) {
            'ngInject';

            this.states = [];
            this.cities = [];
            this._modalService = ModalService;
            this._toastr = toastr;
            this._$state = $state;
            this._compareObjectService = CompareObjectService;
            this.StatementOfBenefitsService = StatementOfBenefitsService;
        }
        $onInit() {
            this.details.displayOnMobile = this.details && this.details.displayOnMobile ? this.details.displayOnMobile : false;
            this.saveData = angular.copy(this.details);
        }

        onAddressChange(addressObject) {
            this.details.address = addressObject;
        }

        onSubmit() {
            let details = {
                value: this.details.plainDescription,
                plainText: this.details.desc
            }
            const isUpdated = this._compareObjectService.deepCompareObjectHasChanged(this.saveData, this.details, true);
                if (isUpdated) {
                    this.disableButtons = true;
                    this.StatementOfBenefitsService.updateDisclaimerInfo(details).then((details) => {
                        this._toastr.success('Statement of benefits updated successfully');
                        this._$state.go('statementOfBenefits');
                    }).catch((err) => {
                        this._toastr.error(err.data[0].message);
                        this.disableButtons = false;
                    });
                }
                else {
                    this._toastr.success('Nothing to update');
                    this._$state.go('statementOfBenefits');
                }
        }

        onCancel() {
            const isUpdated = this._compareObjectService.deepCompareObjectHasChanged(this.saveData, this.details, false);

            if (isUpdated) {
                this._modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No',
                        action() {
                        }
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });

                function _onSubmit() {
                    this._$state.go('statementOfBenefits');
                }
            } else {
                this._$state.go('statementOfBenefits');
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/components/statement-of-benefits/statement-of-benefits-edit/statement-of-benefits-edit.component.js